import './App.css';
import InputTask from './Components/InputTask';

function App() {
  return (
    <>
      <InputTask/>
    </>
  );
}

export default App;
